export default "__VITE_ASSET__BWXI5Anx__"